export default __webpack_public_path__ + "static/all-creatures-19ac539b3818ba935b54031367bc4985.png";